import "./ActionButton.css";

function ActionButton({
  onClick,
  disabled,
  label,
  round,
  wpObjectKey,
  faIconClass
}) {

  const buttonEnabled = wpObjectKey != null && window.wpObject[wpObjectKey] != null ? window.wpObject[wpObjectKey] : true;

  return !buttonEnabled
    ? null
    : (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="base"
    >
      <span>{label}</span> {faIconClass != null && <i class={faIconClass}></i>}
    </button>
  );

}

export function CalculateActionButton({
  disabled,
  onClick,
}) {
  return <ActionButton
    type="button"
    onClick={onClick}
    disabled={disabled != null ? disabled : false}
    label="Beräkna" faIconClass="fas fa-calculator"
  />;

}

export function PrintResultsActionButton({
  disabled,
  onClick,
}) {
  return <ActionButton
    wpObjectKey ="print_results_enabled"
    type="button"
    onClick={onClick}
    disabled={disabled}
    label="Skriv ut" faIconClass="fa-solid fa-print"
  />;

}


export function SaveResultsActionButton({
  disabled,
  onClick,
}) {

  return <ActionButton
    wpObjectKey ="save_results_enabled"
    type="button"
    onClick={onClick}
    disabled={disabled}
    label="Spara" faIconClass="fas fa-save"
  />;

}